import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e6221566&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=e6221566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6221566",
  null
  
)

export default component.exports